/* Default product: mirror the checked option beside each option name.
   Native variant selection and Shopify purchase events remain unchanged. */
(function () {
  function updateFromInput(input) {
    if (!input || !input.matches('[data-variant-input][type="radio"]')) return;
    var wrapper = input.closest('.variant-wrapper[data-type="button"]');
    if (!wrapper || !wrapper.closest('.redcamp-default-pdp')) return;
    var display = wrapper.querySelector('[data-redcamp-selected-option]');
    if (display) display.textContent = input.value;
  }

  document.addEventListener('change', function (event) {
    updateFromInput(event.target);
  });

  /* Theme editor re-renders and the initial selected value both use the
     actual checked input as the source. */
  function initialize(scope) {
    (scope || document).querySelectorAll('.redcamp-default-pdp .variant-wrapper[data-type="button"] input[data-variant-input]:checked')
      .forEach(updateFromInput);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
